import React from 'react';
import { useNavigate } from 'react-router-dom';
import { callNativeAppRemoveLastRoute } from '@front-activerse/common-components';
import { Button } from 'reactstrap';
import useSteps from '../StepContext/useSteps';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

interface IPrevButton {
  asArrow?: boolean;
}

const PrevButton: React.FC<IPrevButton> = ({ asArrow = false }) => {
  const { t } = useTranslator();
  const { prevStep } = useSteps();
  const navigate = useNavigate();

  const {
    images: { backIcon },
  } = useAppContext();

  const displayPrevBtn = () => {
    if (!prevStep) {
      return false;
    }

    return true;
  };

  const handleBack = () => {
    navigate(-1);
    callNativeAppRemoveLastRoute();
  };

  return displayPrevBtn() ? (
    asArrow ? (
      <Button color="" className="px-0 py-0" onClick={handleBack}>
        <img src={backIcon} alt={t('back.button')} />
      </Button>
    ) : (
      <Button color="secondary" outline className="me-l w-100" onClick={handleBack}>
        {t('back.button')}
      </Button>
    )
  ) : null;
};

export default PrevButton;
